import React, { useState } from 'react';
import UpgradeWall from '../components/UpgradeWall';

/**
 * UpgradeWallHarness - Playwright test harness route at /__upgrade-wall.
 *
 * Mounts UpgradeWall in its `open` state so E2E tests can exercise the
 * tier grid, billing toggle, and CTA without needing a tier-gated route.
 * Not linked from anywhere in the UI; reachable only by direct URL.
 */
const UpgradeWallHarness = () => {
  const [open, setOpen] = useState(true);
  return (
    <div data-testid="upgrade-wall-harness-root" className="min-h-screen bg-[#F9F6EF] flex items-center justify-center p-6">
      <UpgradeWall
        open={open}
        onClose={() => setOpen(false)}
        reason="harness-test"
        recommendedTier="connected"
      />
      {!open && (
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="font-mono uppercase text-xs tracking-widest px-5 py-3 rounded-full bg-[#E8A830] text-[#0A1F2E]"
          data-testid="upgrade-wall-harness-reopen"
        >
          Re-open wall
        </button>
      )}
    </div>
  );
};

export default UpgradeWallHarness;
